import React from 'react';
import { VariableHide } from '@grafana/data';
import { selectors } from '@grafana/e2e-selectors';
import { useStyles2, Tooltip } from '@grafana/ui';
import { SceneObjectBase } from '../../core/SceneObjectBase.js';
import { sceneGraph } from '../../core/sceneGraph/index.js';
import { css } from '@emotion/css';

class VariableValueSelectors extends SceneObjectBase {
}
VariableValueSelectors.Component = VariableValueSelectorsRenderer;
function VariableValueSelectorsRenderer({ model }) {
  const variables = sceneGraph.getVariables(model).useState();
  const styles = useStyles2(getStyles);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, variables.variables.map((variable) => /* @__PURE__ */ React.createElement(VariableValueSelectWrapper, {
    key: variable.state.key,
    variable,
    styles
  })));
}
function VariableValueSelectWrapper({
  variable,
  styles
}) {
  const state = variable.useState();
  if (state.hide === VariableHide.hideVariable) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: styles.container
  }, /* @__PURE__ */ React.createElement(VariableLabel, {
    state,
    styles
  }), /* @__PURE__ */ React.createElement(variable.Component, {
    model: variable
  }));
}
function VariableLabel({ state, styles }) {
  var _a;
  if (state.hide === VariableHide.hideLabel) {
    return null;
  }
  const elementId = `var-${state.key}`;
  const labelOrName = (_a = state.label) != null ? _a : state.name;
  if (state.description) {
    return /* @__PURE__ */ React.createElement(Tooltip, {
      content: state.description,
      placement: "bottom"
    }, /* @__PURE__ */ React.createElement("label", {
      className: styles.variableLabel,
      "data-testid": selectors.pages.Dashboard.SubMenu.submenuItemLabels(labelOrName),
      htmlFor: elementId
    }, labelOrName));
  }
  return /* @__PURE__ */ React.createElement("label", {
    className: styles.variableLabel,
    "data-testid": selectors.pages.Dashboard.SubMenu.submenuItemLabels(labelOrName),
    htmlFor: elementId
  }, labelOrName);
}
const getStyles = (theme) => ({
  container: css({
    display: "flex"
  }),
  variableLabel: css({
    background: theme.isDark ? theme.colors.background.primary : theme.colors.background.secondary,
    display: `flex`,
    alignItems: "center",
    padding: theme.spacing(0, 1),
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.bodySmall.fontSize,
    height: theme.spacing(theme.components.height.md),
    lineHeight: theme.spacing(theme.components.height.md),
    borderRadius: theme.shape.borderRadius(1),
    border: `1px solid ${theme.components.input.borderColor}`,
    position: "relative",
    right: -1
  })
});

export { VariableValueSelectors };
//# sourceMappingURL=VariableValueSelectors.js.map
